module.exports = __webpack_public_path__ + "static/media/icon-bank.0e7d457a.svg";